module.exports = __webpack_public_path__ + "static/media/protectedWhite.7d3e7f37.svg";